module.exports = __webpack_public_path__ + "img/candidate_logo.3586ec1c.svg";